/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 11:16:38
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/CloneButton/index.tsx
 */
import React from 'react';
import Button from 'src/components/CloneButton';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { request_get404Page } from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/slice';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';

const CloneBtn = () => {
  const params: any = useParams();
  const { contentUuid } = params;
  const _d = useDispatch();
  const handleOnClick = () => {
    _d(
      request_get404Page({
        //1===true 0===false
        uuid: contentUuid,
        params: {
          [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]: true,
          [EnumSalesChannelMultiLanguage.siteStyleSizeInParams]: true,
          [EnumSalesChannelMultiLanguage.siteStyleInParams]: true,
        },
        isClone: true,
      }),
    );
  };
  return <Button onClick={handleOnClick} />;
};
export default CloneBtn;
